import React from 'react';
import { PatientCard } from './PatientCard';
import { PrimaryButton } from './PrimaryButton';
import { teaserPatients } from '../../data/teaser';
type HookScreenProps = {
  onAnswer: (answer: 'yes' | 'no') => void;
};
export function HookScreen({
  onAnswer
}: HookScreenProps) {
  return <div className="flex h-full flex-col" data-id="element-106" data-mp="38il94sjhg68q">
      <h1 className="text-[30px] font-semibold leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-107" data-mp="38hjmrrx0nxbp">
        Same goal.
        <br data-id="element-108" data-mp="3ne98a39y235r" />
        Same starting approach?
      </h1>
      <p className="mt-3 text-[15px] leading-snug text-graphite" data-id="element-109" data-mp="3ii2bazzj01zy">
        Two patients. Different ovarian reserve. Different body weight.
      </p>

      <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-110" data-mp="5dvi013km3k">
        {teaserPatients.map(p => <PatientCard key={p.id} patient={p} data-id="element-111" data-mp="3s96r21x0zqvu" />)}
      </div>

      <div className="mt-auto pt-6" data-id="element-112" data-mp="a28vyogxkwkh">
        <p className="text-center text-[17px] font-medium tracking-[-0.01em] text-ink" data-id="element-113" data-mp="9z4jl3tbauiq">Would you approach them the same way?</p>
        <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-114" data-mp="29tt0784frizy">
          <PrimaryButton variant="outline" onClick={() => onAnswer('yes')} data-id="element-115" data-mp="29vdqgljpwfs0">
            YES
          </PrimaryButton>
          <PrimaryButton variant="outline" onClick={() => onAnswer('no')} data-id="element-116" data-mp="2eugxgbj9cw2m">
            NO
          </PrimaryButton>
        </div>
      </div>
    </div>;
}